/* src/app/views/products/components/brands/edit-brands/tabs/brand-product-groups-tab/add-product-groups-to-brand-modal/add-product-groups-to-brand-modal.component.scss */
:host ::ng-deep .modal-sticky-header-container {
  padding: 2rem 1.5rem 0 1.5rem !important;
  border-bottom: 1rem solid transparent !important;
}
:host ::ng-deep .modal-header {
  padding: 0;
}
.add-product-groups-to-brand-footer-container {
  display: flex;
  flex-direction: column;
}
.add-product-groups-to-brand-footer-container lib-reactive-table-paginator {
  display: block;
  width: 100%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
/*# sourceMappingURL=add-product-groups-to-brand-modal.component.css.map */
